import React from 'react'
import { getVerticalBarInfo } from './getVerticalBarInfo'
import { positiveBar, negativeBar } from './barSvg'

const Bar = ({bars, bar, data, radius = 10, index, x1Scale, yScale, handleMouseMove, onMouseLeave, x0, showValue, formatValue, padding}) => {
    const barObj = getVerticalBarInfo({
        x: bar.key,
        y: bar.value,
        xScale: x1Scale,
        yScale: yScale,
        data,
        group: bars,
        groupData: data[index]
    })

    const isPositive = barObj.value > 0

    return (
        <>
            {showValue && <foreignObject 
                x={barObj.x} 
                y={isPositive ? barObj.y - 20 : barObj.y + barObj.height } 
                width={bar.width} 
                height="100px"
            >
                <p>{typeof barObj.value === 'number' && formatValue ? formatValue(bar.value) : bar.value}</p> 
            </foreignObject>}
            <GroupBarShape 
                bar={barObj} 
                isPositive={isPositive} 
                radius={radius} 
                color={bar.color} 
                handleMouseMove={handleMouseMove} 
                onMouseLeave={onMouseLeave} 
                x0={x0} 
                padding={padding}
            />
        </>
    )
}

const GroupBarShape = ({bar, isPositive, radius, color, handleMouseMove, onMouseLeave, x0, padding}) => {
    let currentRadius = bar.height > radius ? radius : bar.height
    currentRadius = bar.width > radius + 2 ? currentRadius : 0

    const onMouseMove = () => handleMouseMove({...bar, x: x0 + bar.x + ((bar.width * padding.group) + bar.width * padding.bar), color}) 

    return (
        <>
            {
                bar.height && (
                <path 
                    onMouseMove={onMouseMove}
                    onMouseLeave={onMouseLeave}
                    fill={color}
                    key={`bar-group-bar-svg-${bar.index}-${bar.value}-${bar.key}`}
                    d={isPositive ? positiveBar(bar, currentRadius) : negativeBar(bar, currentRadius)}
                />)
            }
        </>
    )
}

export default Bar